/* Wine By the Case: product page behavior.
   Gallery thumbnails and cursor-tracking hover zoom, variant selection with
   price/sku/availability updates, AJAX add to cart (fires wbtc:cart:updated),
   and the description read-more collapse. Vanilla ES2020, no dependencies. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');

  function debounce(fn, wait) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  /* ------------------------------------------------------------------ */
  /* Gallery: slide switching, thumbnail strip, hover zoom               */
  /* ------------------------------------------------------------------ */
  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var strip = root.querySelector('[data-pdp-thumbs]');

    function show(index) {
      if (index < 0 || index >= slides.length) return;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      if (strip && thumbs[index]) {
        var thumb = thumbs[index];
        var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
        if (typeof strip.scrollTo === 'function') {
          strip.scrollTo({ left: left, behavior: REDUCED.matches ? 'auto' : 'smooth' });
        } else {
          strip.scrollLeft = left;
        }
      }
    }

    function showByMediaId(mediaId) {
      if (!mediaId) return;
      var index = -1;
      slides.forEach(function (slide, i) {
        if (index === -1 && slide.dataset.mediaId === String(mediaId)) index = i;
      });
      if (index > -1) show(index);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(parseInt(thumb.dataset.pdpThumb, 10));
      });
    });

    var zoomOn = root.dataset.zoom === 'true' && FINE_POINTER.matches && !REDUCED.matches;
    if (zoomOn) {
      slides.forEach(function (frame) {
        var img = frame.querySelector('img.bottle-img');
        if (!img) return;
        frame.classList.add('pdp-zoomable');
        frame.addEventListener('mousemove', function (event) {
          var rect = frame.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
          img.style.transform = 'scale(1.9)';
        });
        frame.addEventListener('mouseleave', function () {
          img.style.transform = '';
          img.style.transformOrigin = '';
        });
      });
    }

    return { show: show, showByMediaId: showByMediaId };
  }

  /* ------------------------------------------------------------------ */
  /* Variants: option selects drive price, sku, availability, gallery    */
  /* ------------------------------------------------------------------ */
  function initVariants(root, gallery) {
    var jsonEl = root.querySelector('[data-variant-json]');
    var selects = Array.prototype.slice.call(root.querySelectorAll('[data-option-select]'));
    if (!jsonEl || !selects.length) return;

    var variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = root.querySelector('input[name="id"]');
    var priceWrap = root.querySelector('[data-price-wrap]');
    var pill = root.querySelector('[data-stock-pill]');
    var skuWrap = root.querySelector('[data-sku-wrap]');
    var skuEl = root.querySelector('[data-sku]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var addedBar = root.querySelector('[data-added-bar]');
    var realSoldOut = root.hasAttribute('data-real-sold-out');

    function matchVariant() {
      var picked = selects.map(function (select) { return select.value; });
      for (var i = 0; i < variants.length; i += 1) {
        var candidate = variants[i];
        var hit = true;
        for (var j = 0; j < picked.length; j += 1) {
          if (candidate.options[j] !== picked[j]) {
            hit = false;
            break;
          }
        }
        if (hit) return candidate;
      }
      return null;
    }

    function setPill(inStock, text) {
      if (!pill) return;
      pill.textContent = text;
      pill.classList.toggle('pdp-stock--in', inStock);
      pill.classList.toggle('pdp-stock--out', !inStock);
    }

    function setAtc(enabled, text) {
      if (atc) atc.disabled = !enabled;
      if (atcLabel) atcLabel.textContent = text;
    }

    function renderPrice(variant) {
      if (!priceWrap) return;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      var html;
      if (onSale) {
        html = '<div class="price price--sale">' +
          '<span class="price__sale">' + variant.price_formatted + '</span>' +
          '<s class="price__compare">' + variant.compare_at_price_formatted + '</s>' +
          '</div>';
      } else {
        html = '<div class="price">' +
          '<span class="price__regular">' + variant.price_formatted + '</span>' +
          '</div>';
      }
      priceWrap.innerHTML = html;
    }

    function apply() {
      if (addedBar) addedBar.hidden = true;
      var variant = matchVariant();
      if (!variant) {
        setPill(false, 'Unavailable');
        setAtc(false, 'Unavailable');
        return;
      }
      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      if (skuEl && skuWrap) {
        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuWrap.hidden = false;
        } else {
          skuWrap.hidden = true;
        }
      }
      var soldOut = realSoldOut || !variant.available;
      setPill(!soldOut, soldOut ? 'Sold out' : 'In stock');
      if (variant.price != null) root.dataset.casePrice = String(variant.price);
      setAtc(!soldOut, soldOut ? 'Sold out' : caseLabel(root));
      if (variant.featured_media_id && gallery) {
        gallery.showByMediaId(variant.featured_media_id);
      }
      if (window.history && window.history.replaceState && window.URL) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) {
          /* older browser without URL support: skip the address bar update */
        }
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', apply);
    });
  }

  /* ------------------------------------------------------------------ */
  /* AJAX add to cart                                                    */
  /* ------------------------------------------------------------------ */
  /* Case listings: "1 case / 2 cases" in the stepper, price on the button */
  function caseLabel(root) {
    var size = parseInt(root.dataset.caseSize, 10);
    if (!size) return 'Add to cart';
    var input = root.querySelector('.qty input');
    var n = input ? parseInt(input.value, 10) : 1;
    if (!n || n < 1) n = 1;
    var cents = parseInt(root.dataset.casePrice, 10) || 0;
    var total = '$' + (cents * n / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Add ' + n + (n === 1 ? ' case' : ' cases') + ' \u00b7 ' + total;
  }
  function initCaseLabel(root) {
    if (!root.dataset.caseSize) return;
    var input = root.querySelector('.qty input');
    var unit = root.querySelector('[data-qty-unit]');
    var atc = root.querySelector('[data-atc]');
    var label = root.querySelector('[data-atc-label]');
    if (!input) return;
    function sync() {
      var n = parseInt(input.value, 10);
      if (!n || n < 1) n = 1;
      if (unit) unit.textContent = n === 1 ? 'case' : 'cases';
      if (label && atc && !atc.disabled && !atc.classList.contains('is-loading')) label.textContent = caseLabel(root);
    }
    input.addEventListener('input', sync);
    input.addEventListener('change', sync);
    sync();
  }

  function initAtc(root) {
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    var atc = form.querySelector('[data-atc]');
    var atcLabel = form.querySelector('[data-atc-label]');
    var bar = root.querySelector('[data-added-bar]');
    var barText = root.querySelector('[data-added-text]');
    var barLink = root.querySelector('[data-added-link]');
    var cartUrl = root.dataset.cartUrl || '/cart';
    var busy = false;
    var restoreTimer = null;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy || (atc && atc.disabled)) return;
      busy = true;

      var restingLabel = atcLabel ? atcLabel.textContent : 'Add to cart';
      if (atc) atc.classList.add('is-loading');
      if (atcLabel) atcLabel.textContent = 'Adding...';
      if (bar) bar.hidden = true;

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = (result.data && (result.data.description || result.data.message)) ||
              'Could not add this to your cart.';
            throw new Error(message);
          }
          return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
            .then(function (response) { return response.json(); });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('wbtc:cart:updated', {
            detail: { item_count: cart.item_count }
          }));
          if (bar) {
            bar.classList.remove('pdp-added--error');
            if (barText) barText.textContent = 'Added to your cart.';
            if (barLink) barLink.hidden = false;
            bar.hidden = false;
          }
          if (atcLabel) atcLabel.textContent = 'Added ✓';
          if (restoreTimer) clearTimeout(restoreTimer);
          restoreTimer = setTimeout(function () {
            if (atcLabel) atcLabel.textContent = restingLabel;
          }, 2000);
        })
        .catch(function (error) {
          if (bar) {
            bar.classList.add('pdp-added--error');
            if (barText) barText.textContent = (error && error.message) || 'Could not add this to your cart.';
            if (barLink) barLink.hidden = true;
            bar.hidden = false;
          }
          if (atcLabel) atcLabel.textContent = restingLabel;
        })
        .then(function () {
          busy = false;
          if (atc) atc.classList.remove('is-loading');
        });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Description read-more collapse                                      */
  /* ------------------------------------------------------------------ */
  function initReadMore(root) {
    var body = root.querySelector('[data-pdp-body]');
    var button = root.querySelector('[data-read-more]');
    if (!body || !button) return;

    var label = button.querySelector('[data-read-more-label]');
    var THRESHOLD = 520;

    function measure() {
      if (body.classList.contains('is-expanded')) return;
      var tall = body.scrollHeight > THRESHOLD;
      body.classList.toggle('is-collapsed', tall);
      button.hidden = !tall;
    }

    button.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      body.classList.toggle('is-collapsed', !expanded);
      button.setAttribute('aria-expanded', String(expanded));
      button.classList.toggle('is-open', expanded);
      if (label) label.textContent = expanded ? 'Read less' : 'Read more';
      if (!expanded) {
        var top = body.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: top, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      }
    });

    measure();
    window.addEventListener('load', measure);
    window.addEventListener('resize', debounce(measure, 200));
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */
  function initPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';
    var gallery = initGallery(root);
    initVariants(root, gallery);
    initAtc(root);
    initCaseLabel(root);
    initReadMore(root);
  }

  function boot() {
    document.querySelectorAll('[data-pdp]').forEach(initPdp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-pdp]');
    if (root) initPdp(root);
  });
})();
